module.exports = __webpack_public_path__ + "img/namibia.78387bd0.svg";